import React from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';

// context
import { usePracticeState } from '../../../context/PracticeContext';

const CaseAttributes = ({ newOrder, formErrors, onTextFieldChange }) => {
    const practiceState = usePracticeState();

    // Handler for Autocomplete to keep the practiceId in sync
    const handlePracticeChange = (event, newValue) => {
        const simulatedEvent = {
            target: {
                name: 'practiceId',
                value: newValue ? newValue.practiceId : '',
            },
        };
        onTextFieldChange(simulatedEvent);
    };

    // Get the selected practice object
    const selectedPractice = (practiceState.practices?.items || []).find(
        (practice) => practice.practiceId === newOrder.practiceId
    );

    return (
        <>
            <FormControl key="practice" variant="outlined" onChange={onTextFieldChange} style={{ marginBottom: 35 }}>
                <Autocomplete
                    labelId="practice-label"
                    id="practice"
                    options={practiceState.practices?.items || []}
                    getOptionLabel={(option) => option?.name || ''}
                    value={selectedPractice || null}
                    onChange={handlePracticeChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            name="practiceSearch"
                            label="Select a practice"
                            variant="outlined"
                            required
                            error={formErrors.practiceId}
                            style={{ marginBottom: 15 }}
                        />
                    )}
                />
            </FormControl>

            <TextField
                id="prescriberName"
                label="Prescriber Name"
                onChange={onTextFieldChange}
                name="prescriberName"
                value={newOrder.prescriberName || ''}
                variant="outlined"
                style={{ marginBottom: 35 }}
                helperText="Please enter the prescriber first name and last name"
                required
                error={formErrors.prescriberName}
            />

            <TextField
                id="patientName"
                label="Patient Name"
                onChange={onTextFieldChange}
                value={newOrder.patientName || ''}
                name="patientName"
                variant="outlined"
                style={{ marginBottom: 35 }}
                helperText="Please enter the patient first name and last name"
                required
                error={formErrors.patientName}
            />
        </>
    );
};

export default CaseAttributes;
